export default {
  user_info: {
    user_id: '',
    email: '',
    user_name: '',
    gender: '',
    mobile: '',
    education: '',
    company: '',
    job: '',
    industry: '',
    introducation: '',
    hunter_verify: '',

    city: '',
    career: [],
    token: '',
  },
  alert: {
    text: '',
    type: 'success',
    show: false,
    duration: 0,
  },
  loading: {
    show: false,
  },
}


// WEBPACK FOOTER //
// ./app/store/state.js